import { FunctionComponent } from 'react';
import clsx from 'clsx';
import RadioGroup from 'components/UI/V3/Forms/RadioGroup/RadioGroup';
import styles from './SavedCustomPriceChoice.module.scss';
import { SavedCustomPriceMode } from './useSavedCustomPriceChoice';

interface Props {
    petName: string;
    savedPrice: number;
    mode: SavedCustomPriceMode;
    disabled?: boolean;
    className?: string;
    onChange: (mode: SavedCustomPriceMode) => void;
}

export const SavedCustomPriceChoice: FunctionComponent<Props> = ({
    petName,
    savedPrice,
    mode,
    disabled,
    className,
    onChange
}) => {
    return (
        <div className={clsx(styles.card, className, { [styles.disabled]: disabled })}>
            <div className={styles.header}>
                <span className={styles.label}>Custom price saved for {petName}</span>
                <span className={styles.amount}>${savedPrice.toFixed(2)}</span>
            </div>
            <div className={styles.divider} />
            <RadioGroup<SavedCustomPriceMode>
                value={mode}
                className={styles.radios}
                options={[
                    { value: 'custom', inlineLabel: 'Custom price' },
                    { value: 'standard', inlineLabel: 'Standard Price' }
                ]}
                onChange={onChange}
            />
        </div>
    );
};

export default SavedCustomPriceChoice;
